{
    "AgentList_AddButton_DisabledTooltip": "Bitte wählen Sie in den obigen Filtern einen Telefonieserver und eine Partition aus, um einen Agenten hinzuzufügen.",
    "AgentList_Column_AgentNumber": "Agentennummer",
    "AgentList_Column_PartitionId": "Partitions-ID",
    "AgentList_Column_Monitored": "Überwacht",
    "AgentList_Monitored_Yes": "Ja",
    "AgentList_Monitored_No": "NEIN",
    "AgentList_Column_Description": "Beschreibung",
    "AgentList_Column_InternalNumber": "Interne Nummer",
    "AgentList_Column_PartitionName": "Partitionsname",
    "AgentList_Column_OmniChannel": "Omni-Channel",
    "NAME": "AgentListLanguage"
}